import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  // The actual auth logic is handled in AuthContext's useEffect
  // This component just shows a loading state and redirects after authentication

  useEffect(() => {
    // When authentication is complete (no longer loading), redirect to dashboard
    if (!isLoading) {
      // Navigate to dashboard if authentication was successful, or home if it failed
      if (isAuthenticated) {
        navigate('/dashboard');
      } else {
        navigate('/');
      }
    }
  }, [isLoading, isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
        <h1 className="text-2xl font-semibold">Completing Authentication...</h1>
        <p className="text-muted-foreground">Please wait while we log you in</p>
      </div>
    </div>
  );
};

export default AuthCallback;
